//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Button from '@/components/Shared/Button'
import Card from '@/components/Register/components/Card.vue'
import ContactField from '@/components/Form/ContactField.vue'

export default {
  name: 'ValidateRut',
  middleware: ['user-validate'],
  components: { Card, Button, ContactField },
  props: {
    userNames: {
      type: String,
      default: '',
    },
    phase: {
      type: String,
      default: '0',
    },
    setValue: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      validationValue: null,
      loading: false,
      form: {
        contact: '',
        type: 'email',
      },
    }
  },
  watch: {
    form: {
      handler() {
        this.form[this.form.type] = this.form.contact.toLowerCase()
      },
      deep: true,
    },
  },
  methods: {
    async submit() {
      this.loading = true
      try {
        const isAvailable = await this.isContactAvailable()
        if (!isAvailable) {
          await this.$store.dispatch(
            'core/errorMessage',
            'El contacto ya se encuentra registrado'
          )
          return
        }
        this.form = {
          ...this.form,
          [this.form.type]: this.form.contact,
        }
        this.$emit('setValue', this.form)
      } catch (e) {
        this.$buefy.notification.open({
          message: e.message,
          type: 'is-danger',
          hasIcon: true,
          duration: 7000,
        })
      } finally {
        this.loading = false
      }
    },
    async isContactAvailable() {
      const existuserWithContact = await this.$repository.user.getByContact({
        type: this.form.type,
        contact: this.form.contact,
        user_origin: 'relink',
      })
      return !existuserWithContact?.exists
    },
  },
}
